
export default function ApplicationsSection() {
  const applications = [
    {
      title: "Military Air Bases",
      description: "Secure protection for fighter jets, transport aircraft, and strategic aviation assets with hardened shelter systems.",
      image: "https://static.readdy.ai/image/aae90b02d7a9df21e63cac18235c6f1e/920f1323fec5191501973e22af5e921a.jpeg",
      features: ["Blast resistance", "Security integration", "Climate control", "NBC protection"]
    },
    {
      title: "Commercial Aviation",
      description: "Cost-effective hangar solutions for airlines, cargo operators, and maintenance facilities requiring reliable aircraft protection.",
      image: "https://public.readdy.ai/ai/img_res/d40eaa569989da1d8d38adc23d19a376.jpg",
      features: ["Large span capability", "Maintenance access", "Cost efficiency", "Rapid construction"]
    },
    {
      title: "Private & Corporate",
      description: "Custom hangar solutions for private aircraft owners and corporate fleets requiring premium protection and accessibility.",
      image: "https://readdy.ai/api/search-image?query=Private%20aircraft%20hangar%20with%20luxury%20business%20jets%2C%20upscale%20aviation%20facility%2C%20modern%20corporate%20hangar%20design%2C%20premium%20quality%20construction%2C%20professional%20lighting&width=500&height=300&seq=private-hangar&orientation=landscape",
      features: ["Custom sizing", "Premium finishes", "Easy access", "Aesthetic design"]
    }
  ];

  return (
    <section id="applications" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>Applications</strong> Across Aviation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our arch panel systems serve diverse aviation needs from military installations to private hangars.
          </p>
        </div>

        <div className="space-y-16">
          {applications.map((app, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="flex-1">
                <img 
                  src={app.image}
                  alt={app.title}
                  className="w-full h-80 object-cover object-top rounded-xl shadow-lg"
                />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">{app.title}</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">{app.description}</p>
                <div className="grid grid-cols-2 gap-4">
                  {app.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center">
                      <i className="ri-check-double-line text-blue-600 mr-2"></i>
                      <span className="text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
                <button className="mt-6 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
